import { render, staticRenderFns } from "./InvoiceLineGroup.yaml?vue&type=template&id=22c10a78&component"
import script from "./InvoiceLineGroup.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceLineGroup.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports